import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import CtaBand from "@/components/CtaBand";
import { ROLES, INDIA_ADVANTAGE } from "@/lib/content";

const Roles = () => {
  return (
    <>
      <PageHeader
        eyebrow="Roles"
        title="Roles we can help you hire and support."
        subtitle="Remote-friendly positions across sales, admin, recruitment, marketing, operations and client support — all built for UK businesses running India-based teams."
      />

      <section className="py-20 lg:py-28" data-testid="roles-detail">
        <div className="mx-auto max-w-6xl px-6 md:px-10 lg:px-12">
          <div className="grid gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {ROLES.map((role) => (
              <div
                key={role}
                className="rounded-2xl border border-slate-200 bg-white px-5 py-4 text-[14px] font-medium text-navy hover:border-aqua/50 hover:bg-aqua/5 transition-colors flex items-center gap-3"
                data-testid={`role-detail-${role.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
              >
                <span className="w-1.5 h-1.5 rounded-full bg-aqua" />
                {role}
              </div>
            ))}
          </div>

          <div className="mt-14 grid gap-8 lg:grid-cols-2 items-start">
            <div>
              <p className="text-xs uppercase tracking-[0.22em] text-aqua font-semibold">The India advantage</p>
              <h2 className="font-display mt-4 text-3xl sm:text-4xl font-semibold text-navy tracking-tight leading-[1.08]">
                Why India works for these roles.
              </h2>
              <p className="mt-5 text-lg text-slateink leading-relaxed">
                A large, skilled and ambitious talent pool with strong English, UK time overlap and deep experience across the exact remote roles UK businesses need to scale.
              </p>
            </div>
            <div className="grid gap-3 sm:grid-cols-2">
              {INDIA_ADVANTAGE.map((line) => (
                <div key={line} className="rounded-2xl border border-slate-200 bg-white p-5">
                  <div className="flex items-start gap-3">
                    <div className="mt-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-aqua/15">
                      <Check className="h-3.5 w-3.5 text-aqua" strokeWidth={2.5} />
                    </div>
                    <p className="text-[14.5px] text-slateink leading-relaxed">{line}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-14 rounded-3xl bg-aqua/5 border border-aqua/30 p-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <p className="text-[15px] text-navy max-w-2xl">
              <strong className="font-semibold">Already have someone in India you want to hire?</strong> Bright EOR can help with the employment and onboarding structure.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-full bg-navy px-5 py-3 text-sm font-medium text-white hover:bg-aqua hover:text-navy transition-colors"
              data-testid="roles-detail-cta"
            >
              Speak to Bright EOR <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
};

export default Roles;
